import React, {useEffect, useState} from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import {useNavigate} from "react-router-dom";
import {POST} from "APIclient";
import properties from "constants/ApplicationConstants";

const styles = {
  page: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center",
    padding: "16px 16px",
    background: "linear-gradient(135deg, #f0f4ff 0%, #fafbff 60%, #eef2ff 100%)",
    fontFamily: "'DM Sans', 'Segoe UI', sans-serif"
  },
  card: {
    width: "100%",
    maxWidth: 480,
    borderRadius: 20,
    overflow: "hidden",
    boxShadow: "0 24px 64px rgba(67,97,238,0.13), 0 4px 16px rgba(0,0,0,0.07)",
    background: "#ffffff",
    animation: "slideUp 0.45s cubic-bezier(.22,1,.36,1) both"
  },
  header: {
    background: "linear-gradient(135deg, #3b55e6 0%, #5e75f5 100%)",
    padding: "20px 28px 18px",
    position: "relative",
    overflow: "hidden"
  },
  headerCircle1: {
    position: "absolute",
    width: 160,
    height: 160,
    borderRadius: "50%",
    background: "rgba(255,255,255,0.08)",
    top: -50,
    right: -40,
    pointerEvents: "none"
  },
  headerCircle2: {
    position: "absolute",
    width: 80,
    height: 80,
    borderRadius: "50%",
    background: "rgba(255,255,255,0.06)",
    bottom: -20,
    left: 20,
    pointerEvents: "none"
  },
  lockIcon: {
    width: 40,
    height: 40,
    borderRadius: 12,
    background: "rgba(255,255,255,0.18)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 10,
    backdropFilter: "blur(4px)"
  },
  headerTitle: {
    color: "#ffffff",
    fontSize: "1.45rem",
    fontWeight: 700,
    fontFamily: properties.fontFamily,
    margin: 0,
    letterSpacing: "-0.3px"
  },
  headerSub: {
    color: "rgba(255,255,255,0.72)",
    fontSize: "0.82rem",
    marginTop: 4,
    fontWeight: 400,
    fontFamily: properties.fontFamily
  },
  adminBadge: {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    background: "rgba(255,255,255,0.18)",
    borderRadius: 20,
    padding: "4px 12px",
    marginTop: 12,
    color: "#fff",
    fontSize: "0.78rem",
    fontWeight: 600,
    letterSpacing: "0.3px",
    backdropFilter: "blur(6px)"
  },
  body: {
    padding: "20px 28px"
  },
  fieldGroup: {
    marginBottom: 14
  },
  label: {
    display: "block",
    fontSize: "0.78rem",
    fontWeight: 600,
    color: "#4a5568",
    marginBottom: 7,
    letterSpacing: "0.4px",
    textTransform: "uppercase"
  },
  required: {
    color: "#e53e3e",
    marginLeft: 2
  },
  inputWrapper: {
    position: "relative"
  },
  input: {
    width: "100%",
    padding: "10px 44px 10px 14px",
    borderRadius: 10,
    border: "1.5px solid #e2e8f0",
    background: "#f8fafc",
    fontSize: "0.91rem",
    color: "#2d3748",
    outline: "none",
    transition: "border-color 0.2s, box-shadow 0.2s, background 0.2s",
    boxSizing: "border-box",
    fontFamily: "inherit"
  },
  inputError: {
    borderColor: "#fc8181",
    background: "#fff5f5"
  },
  inputFocus: {
    borderColor: "#3b55e6",
    background: "#ffffff",
    boxShadow: "0 0 0 3px rgba(59,85,230,0.10)"
  },
  eyeBtn: {
    position: "absolute",
    right: 14,
    top: "50%",
    transform: "translateY(-50%)",
    background: "none",
    border: "none",
    cursor: "pointer",
    color: "#a0aec0",
    padding: 0,
    display: "flex",
    alignItems: "center",
    transition: "color 0.15s"
  },
  errorMsg: {
    color: "#e53e3e",
    fontSize: "0.74rem",
    marginTop: 5,
    display: "flex",
    alignItems: "center",
    gap: 4,
    fontWeight: 500
  },
  strengthBar: {
    marginTop: 8,
    display: "flex",
    gap: 4
  },
  divider: {
    height: 1,
    background: "#edf2f7",
    margin: "4px 0 16px"
  },
  actions: {
    display: "flex",
    gap: 12,
    justifyContent: "flex-end"
  },
  btnBack: {
    padding: "11px 24px",
    borderRadius: 10,
    border: "1.5px solid #e2e8f0",
    background: "#ffffff",
    color: "#4a5568",
    fontWeight: 600,
    fontSize: "0.88rem",
    cursor: "pointer",
    fontFamily: "inherit",
    transition: "background 0.15s, border-color 0.15s",
    display: "flex",
    alignItems: "center",
    gap: 6
  },
  btnSubmit: {
    padding: "11px 28px",
    borderRadius: 10,
    border: "none",
    background: "linear-gradient(135deg, #3b55e6 0%, #5e75f5 100%)",
    color: "#ffffff",
    fontWeight: 700,
    fontSize: "0.88rem",
    cursor: "pointer",
    fontFamily: "inherit",
    transition: "opacity 0.15s, transform 0.15s",
    display: "flex",
    alignItems: "center",
    gap: 6,
    boxShadow: "0 4px 16px rgba(59,85,230,0.28)"
  },
  btnSubmitDisabled: {
    opacity: 0.45,
    cursor: "not-allowed",
    transform: "none"
  },
  toast: {
    position: "fixed",
    top: 24,
    right: 24,
    zIndex: 9999,
    padding: "14px 20px",
    borderRadius: 12,
    display: "flex",
    alignItems: "center",
    gap: 10,
    fontSize: "0.87rem",
    fontWeight: 600,
    fontFamily: "inherit",
    boxShadow: "0 8px 32px rgba(0,0,0,0.14)",
    animation: "toastIn 0.35s cubic-bezier(.22,1,.36,1) both",
    maxWidth: 340
  },
  toastSuccess: {
    background: "#f0fff4",
    color: "#276749",
    border: "1.5px solid #9ae6b4"
  },
  toastError: {
    background: "#fff5f5",
    color: "#c53030",
    border: "1.5px solid #feb2b2"
  }
};

const globalCSS = `
  @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&display=swap');
  @keyframes slideUp {
    from { opacity: 0; transform: translateY(28px); }
    to   { opacity: 1; transform: translateY(0); }
  }
  @keyframes toastIn {
    from { opacity: 0; transform: translateX(40px); }
    to   { opacity: 1; transform: translateX(0); }
  }
  input:-webkit-autofill {
    -webkit-box-shadow: 0 0 0 100px #f8fafc inset !important;
  }
`;

function getStrength(pw) {
  if (!pw) return 0;
  let s = 0;
  if (pw.length >= 8) s++;
  if (/[A-Z]/.test(pw)) s++;
  if (/[0-9]/.test(pw)) s++;
  if (/[@$!%*?&]/.test(pw)) s++;
  return s;
}

const strengthLabels = ["", "Weak", "Fair", "Good", "Strong"];
const strengthColors = ["", "#fc8181", "#f6ad55", "#68d391", "#48bb78"];

function EyeIcon({open}) {
  return open ? (
    <svg
      width="18"
      height="18"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      viewBox="0 0 24 24"
    >
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  ) : (
    <svg
      width="18"
      height="18"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      viewBox="0 0 24 24"
    >
      <path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94" />
      <path d="M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19" />
      <line x1="1" y1="1" x2="23" y2="23" />
    </svg>
  );
}

function PasswordField({label, name, value, onChange, error, showStrength, strength}) {
  const [show, setShow] = useState(false);
  const [focused, setFocused] = useState(false);

  const inputStyle = {
    ...styles.input,
    ...(error ? styles.inputError : {}),
    ...(focused ? styles.inputFocus : {})
  };

  return (
    <div style={styles.fieldGroup}>
      <label style={styles.label}>
        {label}
        <span style={styles.required}>*</span>
      </label>
      <div style={styles.inputWrapper}>
        <input
          type={show ? "text" : "password"}
          name={name}
          value={value}
          onChange={onChange}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          style={inputStyle}
          autoComplete="off"
        />
        <button type="button" style={styles.eyeBtn} onClick={() => setShow(s => !s)} tabIndex={-1}>
          <EyeIcon open={show} />
        </button>
      </div>
      {showStrength && value && (
        <div>
          <div style={styles.strengthBar}>
            {[1, 2, 3, 4].map(i => (
              <div
                key={i}
                style={{
                  flex: 1,
                  height: 4,
                  borderRadius: 4,
                  background: i <= strength ? strengthColors[strength] : "#e2e8f0",
                  transition: "background 0.3s"
                }}
              />
            ))}
          </div>
          {strength > 0 && (
            <div
              style={{
                fontSize: "0.72rem",
                marginTop: 4,
                color: strengthColors[strength],
                fontWeight: 600
              }}
            >
              {strengthLabels[strength]} password
            </div>
          )}
        </div>
      )}
      {error && (
        <div style={styles.errorMsg}>
          <svg width="12" height="12" fill="currentColor" viewBox="0 0 20 20">
            <path
              fillRule="evenodd"
              d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
              clipRule="evenodd"
            />
          </svg>
          {error}
        </div>
      )}
    </div>
  );
}

function AdminChangePassword() {
  const navigate = useNavigate();

  const [toast, setToast] = useState({open: false, color: "", message: ""});
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    newPassword: "",
    oldPassword: "",
    confirmPassword: "",
    username: null
  });
  const [formErrors, setFormErrors] = useState({
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
    username: ""
  });

  useEffect(() => {
    const username = JSON.parse(window.sessionStorage.getItem("username"));
    setFormData(prev => ({...prev, username}));
  }, []);

  useEffect(() => {
    if (toast.open) {
      const t = setTimeout(() => setToast(s => ({...s, open: false})), 2800);
      return () => clearTimeout(t);
    }
  }, [toast.open]);

  const validateInput = (name, value, data = formData) => {
    if (!value?.trim()) {
      const labels = {
        oldPassword: "Old password",
        newPassword: "New password",
        confirmPassword: "Confirm password",
        username: "Username"
      };
      return `${labels[name]} is required`;
    }
    if (name === "newPassword") {
      if (value.length < 8) return "Must be at least 8 characters long.";
      if (!/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d@$!%*?&]{8,}$/.test(value))
        return "Must contain both letters and numbers.";
    }
    if (name === "confirmPassword" && value !== data.newPassword) return "Passwords do not match.";
    return "";
  };

  const handleChange = e => {
    const {name, value} = e.target;
    const updated = {...formData, [name]: value};
    setFormData(updated);
    setFormErrors(prev => ({...prev, [name]: validateInput(name, value, updated)}));
  };

  const handleSubmit = async () => {
    const errors = {
      oldPassword: validateInput("oldPassword", formData.oldPassword),
      newPassword: validateInput("newPassword", formData.newPassword),
      confirmPassword: validateInput("confirmPassword", formData.confirmPassword),
      username: validateInput("username", formData.username)
    };
    setFormErrors(errors);
    if (Object.values(errors).some(e => e)) return;

    setIsLoading(true);
    try {
      const {oldPassword, newPassword, username} = formData;
      const response = await POST("admin/change-admin-password", {
        oldPassword,
        newPassword,
        username
      });
      if (response?.data?.statusCode === 200) {
        setToast({open: true, color: "success", message: "Password updated successfully!"});
        setFormData(f => ({...f, oldPassword: "", newPassword: "", confirmPassword: ""}));
      } else {
        setToast({
          open: true,
          color: "error",
          message: response?.data?.message || "Failed to update password."
        });
      }
    } catch {
      setToast({open: true, color: "error", message: "Error updating password."});
    } finally {
      setIsLoading(false);
    }
  };

  const displayUserName = () => {
    if (formData.username) {
      return formData.username.charAt(0).toUpperCase() + formData.username.slice(1);
    }
    return "";
  };

  const isDisabled =
    !formData.oldPassword ||
    !formData.newPassword ||
    !formData.confirmPassword ||
    !formData.username ||
    isLoading;

  const strength = getStrength(formData.newPassword);

  return (
    <DashboardLayout>
      <style>{globalCSS}</style>
      <DashboardNavbar />
      <div style={styles.page}>
        <div style={styles.card}>
          <div style={styles.header}>
            <div style={styles.headerCircle1} />
            <div style={styles.headerCircle2} />
            <div style={styles.lockIcon}>
              <svg
                width="22"
                height="22"
                fill="none"
                stroke="#fff"
                strokeWidth="2.2"
                viewBox="0 0 24 24"
              >
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                <path d="M7 11V7a5 5 0 0110 0v4" />
              </svg>
            </div>
            <p style={styles.headerTitle}>Change Password</p>
            <p style={styles.headerSub}>Update your admin account credentials securely</p>
            {formData.username && (
              <span style={styles.adminBadge}>
                <svg width="12" height="12" fill="currentColor" viewBox="0 0 20 20">
                  <path
                    fillRule="evenodd"
                    d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-5-6a3 3 0 11-6 0 3 3 0 016 0zm-3 8a5 5 0 00-4.546 2.916A5.986 5.986 0 0010 16a5.986 5.986 0 004.546-2.084A5 5 0 0010 12z"
                    clipRule="evenodd"
                  />
                </svg>
                {displayUserName()}
              </span>
            )}
          </div>

          <div style={styles.body}>
            <PasswordField
              label="Current Password"
              name="oldPassword"
              value={formData.oldPassword}
              onChange={handleChange}
              error={formErrors.oldPassword}
            />
            <PasswordField
              label="New Password"
              name="newPassword"
              value={formData.newPassword}
              onChange={handleChange}
              error={formErrors.newPassword}
              showStrength
              strength={strength}
            />
            <PasswordField
              label="Confirm New Password"
              name="confirmPassword"
              value={formData.confirmPassword}
              onChange={handleChange}
              error={formErrors.confirmPassword}
            />

            <div style={styles.divider} />

            <div style={styles.actions}>
              <button
                style={styles.btnBack}
                onClick={() => navigate(-1)}
                onMouseOver={e => (e.currentTarget.style.background = "#f7fafc")}
                onMouseOut={e => (e.currentTarget.style.background = "#ffffff")}
              >
                <svg
                  width="16"
                  height="16"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  viewBox="0 0 24 24"
                >
                  <path d="M19 12H5M12 19l-7-7 7-7" />
                </svg>
                Back
              </button>
              <button
                style={{...styles.btnSubmit, ...(isDisabled ? styles.btnSubmitDisabled : {})}}
                onClick={handleSubmit}
                disabled={isDisabled}
                onMouseOver={e => {
                  if (!isDisabled) e.currentTarget.style.transform = "translateY(-1px)";
                }}
                onMouseOut={e => {
                  e.currentTarget.style.transform = "translateY(0)";
                }}
              >
                {isLoading ? (
                  <>
                    <svg
                      width="15"
                      height="15"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2.5"
                      style={{animation: "spin 0.8s linear infinite"}}
                    >
                      <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83" />
                    </svg>
                    Updating...
                  </>
                ) : (
                  <>
                    <svg
                      width="16"
                      height="16"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2.5"
                      viewBox="0 0 24 24"
                    >
                      <path d="M20 6L9 17l-5-5" />
                    </svg>
                    Update Password
                  </>
                )}
              </button>
            </div>
          </div>
        </div>

        {toast.open && (
          <div
            style={{
              ...styles.toast,
              ...(toast.color === "success" ? styles.toastSuccess : styles.toastError)
            }}
          >
            {toast.color === "success" ? (
              <svg
                width="18"
                height="18"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                viewBox="0 0 24 24"
              >
                <path d="M22 11.08V12a10 10 0 11-5.93-9.14" />
                <polyline points="22 4 12 14.01 9 11.01" />
              </svg>
            ) : (
              <svg
                width="18"
                height="18"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                viewBox="0 0 24 24"
              >
                <circle cx="12" cy="12" r="10" />
                <line x1="15" y1="9" x2="9" y2="15" />
                <line x1="9" y1="9" x2="15" y2="15" />
              </svg>
            )}
            {toast.message}
          </div>
        )}
      </div>
    </DashboardLayout>
  );
}

export default AdminChangePassword;
